import { useState, useEffect } from 'react'
import {
  Label,
  Input,
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue
} from '@creanizer/ui'

interface SelectWithCustomProps {
  label: string
  value?: string
  onChange: (value: string) => void
  presets: string[]
  placeholder?: string
}

export function SelectWithCustom({ 
  label, 
  value, 
  onChange, 
  presets, 
  placeholder = "選択してください" 
}: SelectWithCustomProps) {
  // カスタム値の状態管理
  const [isCustomMode, setIsCustomMode] = useState(false)
  const [customValue, setCustomValue] = useState('')
  
  // 初期化: プリセットに含まれない値がある場合はカスタムモード
  useEffect(() => {
    if (value && value !== 'カスタム' && !presets.filter(p => p !== 'カスタム').includes(value)) {
      setIsCustomMode(true)
      setCustomValue(value)
    }
  }, [value, presets])
  
  const handleSelectChange = (v: string) => {
    if (v === 'カスタム') {
      setIsCustomMode(true)
      // カスタムを選択しても値は変更しない（空の場合のみ）
      if (!customValue) {
        setCustomValue('')
      }
    } else {
      setIsCustomMode(false)
      setCustomValue('')
      onChange(v)
    }
  }
  
  const handleCustomChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value
    setCustomValue(newValue)
    // 値が入力されたら即座に反映
    onChange(newValue)
  }
  
  // 表示値の決定
  let selectValue = value || ''
  if (isCustomMode || (value && !presets.filter(p => p !== 'カスタム').includes(value))) {
    selectValue = 'カスタム'
  }
  
  return (
    <div className="space-y-2">
      <Label>{label}</Label>
      <Select value={selectValue} onValueChange={handleSelectChange}>
        <SelectTrigger>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {presets.map(item => (
            <SelectItem key={item} value={item}>{item}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      {isCustomMode && (
        <Input
          placeholder={`${label}をカスタム入力`}
          value={customValue}
          onChange={handleCustomChange}
          autoFocus
        />
      )}
    </div>
  )
}